import { EventEmitter, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { environment } from 'src/environments/environment';
import { ShareValuesService } from '../../services/sharedValues/share-values.service';
import { UserAuthService } from '../../services/user-auth/user-auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationServiceService {
  result: any;
  results = [];
  notifyMsg: any;
  responeMsg: any;
  openResult: any;
  onMessageReceived = new EventEmitter<any>();

  constructor(public sharedValue: ShareValuesService, private userAuthService: UserAuthService, public backendService: BackendCallService,) {
    if (this.userAuthService.checkMsalAuth()) {
      this.createConnection();
    }
  }

  public async createConnection() {
    this.loadExistingNotifications();
    const token = this.userAuthService.getAccessToken();
    const connection = new HubConnectionBuilder()
      .withUrl(`${environment.tokenEndpoint}` + '/hub/notificationhub',
        {
          accessTokenFactory: () => token
          , transport: signalR.HttpTransportType.WebSockets
        })
      .configureLogging(LogLevel.Debug)
      .build();
    connection.on('ClientNotification', (data: any) => {
        console.log('SignalR Message :' + data);

        const payload = this.getStructuredPayload(data);
        const notificationText = this.getNotificationText(data, payload);
        const notificationExists = this.results.some(item => item.notification === notificationText);
        if (!notificationExists) {
          const newNotification = {
            ...payload,
            notification: notificationText,
            id: payload.id || Date.now().toString(),
            read: false
          };
          this.results.push(newNotification);
          localStorage.setItem('notificationvalue', JSON.stringify(this.results));
          this.sharedValue.finalNotification = [...this.results];
          document.dispatchEvent(new CustomEvent('notifications', {
            detail: this.results
          }));
          this.sharedValue.notifications$.next([...this.results]);
          console.log('notifications', this.sharedValue.finalNotification.slice().reverse());
        } else {
          console.log('Duplicate notification skipped:', data);
        }
    });
    try {
        await connection.start();
        console.log('connected');
    } catch (err) {
        console.error('Unable to connect to the notification hub:', err);
    }
  }

  private getStructuredPayload(data: any): any {
    if (data && typeof data === 'object') {
      return data;
    }

    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch {
        return {};
      }
    }

    return {};
  }

  private getNotificationText(data: any, payload: any): string {
    const text = payload.notification || payload.text || payload.message
      || (typeof data === 'string' ? data : '');
    return typeof text === 'string' ? text : JSON.stringify(text);
  }

  private loadExistingNotifications() {
    const storedNotifications = localStorage.getItem('notificationvalue');
    if (storedNotifications) {
      try {
        this.results = JSON.parse(storedNotifications);
        this.sharedValue.finalNotification = [...this.results];
        this.sharedValue.notifications$.next([...this.results]);
      } catch (error) {
        console.error('Error parsing stored notifications:', error);
        this.results = [];
        this.sharedValue.finalNotification = [];
        this.sharedValue.notifications$.next([]);
        localStorage.removeItem('notificationvalue');
      }
    } else {
      this.results = [];
      this.sharedValue.finalNotification = [];
      this.sharedValue.notifications$.next([]);
    }
  }
}
